import axios, { AxiosResponse } from 'axios';

// POST
// /ewosapi/v1/planandprognosis/site/{globalSiteId}/forecast
export const postSiteForecast = async (globalSiteId: string, comment: string): Promise<AxiosResponse> => {
  return await axios.post<AxiosResponse>(`/ewosapi/v1/planandprognosis/site/${globalSiteId}/forecast`, { comment });
};
